import reducer from './reducer';
import { MODULE_NAME, ORDER_STATUS, BILL_STATUS, BILL_TILE_TYPE } from './constants';
import OrderWebSocket from './orderWebSocket';
import BillWebSocket from './billWebSocket';

export {
    addOrderPosition,
    increaseQuantity,
    decreaseQuantity,
    setSelectedMenuPosition,
    clearSelectedMenuPosition,
    decreaseOrderPositionQuantity,
    increaseOrderPositionQuantity,
    connectOrdersSocket,
    disconnectOrdersSocket,
    connectBillSocket,
    disconnectBillSocket,
    clearAddOrderPositionErrorMessage,
    submitOrder,
    submitCloseBill,
    setAddonAsSelected,
    setAddonAsUnselected,
    changeComment,
    addAddon,
    removeAddon,
    cancelOrder,
    repayment,
    clearSubmitErrorMessage,
    clearCancelOrderErrorMessage,
    clearRepaymentErrorMessage,
    clearAskForBillError
} from './actions';

export {
    selectOrders,
    selectAreOrdersFetched,
    selectMenuPositionConfigurator,
    selectIsOrderPositionAdded,
    selectOrderSummary,
    selectOrderContext,
    selectAddOrderPositionError,
    selectShouldCreateNewOrder,
    selectLastOrderStatus,
    selectIsOrderContextDefined,
    selectIsSubmitOrderPending,
    selectCanOrder,
    selectIsAnyPlacedOrder,
    selectValidationErrors,
    selectIsPaymentAllow,
    selectNewOrderPositionCount,
    selectCanCreateOrders,
    selectPlacedAndAcceptedOrderPositionCount,
    selectIsAddingPositionAllowed,
    selectIsAskForBillPending,
    selectNotification,
    selectReinitialize,
    selectSessionError,
    selectClientOrders,
    selectIsReadOnlyMenu,
    selectIsAnyOrder,
    selectExternalPayment,
    selectOrderStatus,
    selectSubmitOrderError,
    selectLastBillStatus,
    selectLastBillSummary,
    selectCancelOrderError,
    selectRepaymentError,
    selectIsAddPositionDisabled,
    selectShouldShowSessionEndedMessage,
    selectAskForBillError
} from './selectors';

export { ORDER_STATUS, BILL_STATUS, BILL_TILE_TYPE };

export default {
    reducer,
    moduleName: MODULE_NAME,
    WebSockets: [OrderWebSocket, BillWebSocket]
};
